
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"16","height":"16","rx":"8","fill":"#FCDFE0"}}),_c('path',{attrs:{"d":"M8.46 4.096a.4.4 0 00-.52 0l-.036.031a12.61 12.61 0 00-.421.393c-.27.263-.63.637-.992 1.076-.36.438-.729.949-1.009 1.489C5.204 7.62 5 8.21 5 8.8a3.2 3.2 0 106.4 0c0-.589-.204-1.18-.482-1.715a8.72 8.72 0 00-1.01-1.49A13.704 13.704 0 008.59 4.212l-.129-.115zM5.8 8.8c0-.411.146-.87.393-1.347.245-.473.576-.937.916-1.349A12.904 12.904 0 018.2 4.941a12.766 12.766 0 011.091 1.163c.34.412.671.876.916 1.349.247.476.393.936.393 1.347a2.4 2.4 0 11-4.8 0z","fill":"#F16063"}}),_c('path',{attrs:{"d":"M6.744 8.817a.4.4 0 00-.27.497c.174.581.63 1.038 1.212 1.211a.4.4 0 10.228-.766 1.003 1.003 0 01-.673-.673.4.4 0 00-.497-.27z","fill":"#F16063"}})])
          )
        }
      }
    